export default "__VITE_ASSET__01f1ce9b__"